/**
 * Settings 页面共享工具函数和常量
 */

export const roleOptions = [
  { value: 'RD', label: '研究 (RD)' },
  { value: 'QC', label: '质量控制 (QC)' },
  { value: 'Ops', label: '执行 (Ops)' },
  { value: 'agent', label: '代理 (Agent)' },
  { value: 'viewer', label: '查看者 (Viewer)' }
]

export const roleDescriptions = {
  RD: { title: 'RD', desc: '该角色拥有研究权限，可以查看、编辑和管理项目中的实验数据，但无法修改项目全局配置。' },
  QC: { title: 'QC', desc: '质量控制角色，负责审核和验证项目数据质量，可以标记问题并提出修改建议。' },
  Ops: { title: 'Ops', desc: '执行角色，负责项目的日常运营和任务分配，可以管理波次和分配任务。' },
  Agent: { title: 'Agent', desc: '代理角色，负责线下执行和数据采集，可以填写问卷和上传现场数据。' },
  agent: { title: '代理', desc: '代理角色，负责线下执行和数据采集，可以管理神客和分配任务。' },
  Factory: { title: '厂家', desc: '厂家角色，可以查看项目进度和数据报表，对问卷结果进行审核和反馈。' },
  Dealer: { title: '店端', desc: '店端角色，代表经销商参与项目，可以查看本店相关数据和整改要求。' },
  viewer: { title: 'Viewer', desc: '仅查看权限，可以浏览项目数据和报表，但无法进行任何修改操作。' }
}

export function formatDate(time) {
  if (!time) return '-'
  const d = new Date(time)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function getInitial(m) {
  const name = m.name || m.Username || m.username || ''
  return name.substring(0, 1) || '?'
}

export function getAvatarColor(m) {
  const colors = ['#1476ff', '#e6a23c', '#f56c6c', '#67c23a', '#909399', '#e040fb']
  const name = m.name || m.Username || m.username || ''
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return colors[Math.abs(hash) % colors.length]
}

export function getRoleBg(role) {
  const map = { admin: '#fef0f0', RD: '#ecf5ff', QC: '#fdf6ec', Ops: '#fef0f0', Agent: '#f0f9eb', Factory: '#fef7ed', Dealer: '#f0f4ff', viewer: '#f4f4f5', member: '#ecf5ff', reviewer: '#fff7ed' }
  return map[role] || '#f4f4f5'
}

export function getRoleColor(role) {
  const map = { admin: '#f56c6c', RD: '#409eff', QC: '#e6a23c', Ops: '#f56c6c', Agent: '#67c23a', Factory: '#d97706', Dealer: '#6366f1', viewer: '#909399', member: '#409eff', reviewer: '#e6a23c' }
  return map[role] || '#909399'
}

export function getRoleLabel(role) {
  const map = { admin: '管理员', RD: '研究 (RD)', QC: '质量控制 (QC)', Ops: '执行 (Ops)', Agent: '代理 (Agent)', Factory: '厂家', Dealer: '店端', viewer: '查看者', member: '成员', reviewer: '审核员' }
  return map[role] || role || '-'
}

export function downloadBlob(res, defaultName) {
  const data = res.data || res
  const blob = data instanceof Blob ? data : new Blob([data])
  const disposition = res.headers?.['content-disposition'] || ''
  let filename = defaultName
  const matchStar = disposition.match(/filename\*=\s*(?:UTF-8''|utf-8'')([^;\s]+)/i)
  if (matchStar) {
    filename = decodeURIComponent(matchStar[1])
  } else {
    const matchPlain = disposition.match(/filename=["']?([^"';\s]+)["']?/i)
    if (matchPlain) filename = decodeURIComponent(matchPlain[1])
  }
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  window.URL.revokeObjectURL(url)
}
